import React from 'react';
import PropTypes from 'prop-types';

import CardViewBtn from 'Components/Button/Card/CardViewBtn';
import AddToCartBtn from 'Components/Button/Cart/AddToCartCardBtn';

function HitCardButtons({
  hit,
  noGermanRelease,
  place,
  payWhatYouWant,
  hideViewButton,
  clickFunction,
}) {
  const isPromotion = (hit.type === 'pick-and-mix');

  return (
    <div className="hit-card-buttons-container">
      {!hideViewButton &&
        <CardViewBtn hit={hit} place={place} clickFunction={clickFunction} />
      }

      {!hit.hide_discount && !isPromotion &&
        !hit.tiered && !hit.presale && !noGermanRelease && !hit.free_to_play && !payWhatYouWant &&
        <AddToCartBtn
          showInCartLink
          id={hit.product_id}
          slug={hit.slug}
          voucherToAdd={hit.addVoucher}
          place={place}
          clickFunction={clickFunction}
        />
      }
    </div>
  );
}

HitCardButtons.propTypes = {
  hit: PropTypes.shape({}),
  noGermanRelease: PropTypes.bool,
  place: PropTypes.string,
  payWhatYouWant: PropTypes.bool,
  hideViewButton: PropTypes.bool,
  clickFunction: PropTypes.func,
};

HitCardButtons.defaultProps = {
  hit: {},
  noGermanRelease: false,
  place: '',
  payWhatYouWant: false,
  hideViewButton: false,
  clickFunction: () => { },
};

export default HitCardButtons;
